// Relay
import createQueryRenderer from 'Relay/createQueryRenderer';

import { ReportConfigEditor } from './index.component';
import ReportConfigEditorQuery from './ReportConfigEditorQuery';

export default createQueryRenderer(ReportConfigEditor, ReportConfigEditorQuery);
